// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"8256":"6f0ccf30fa54f78b","9382":"c1c3760323f35ded"}[chunkId] + ".js";
};